<template>
    <div class="nevs-content">
        <div class="nevs-content-top-buttons">
            <NevsButton class="primary" @click="addClick">
                <i class="fa-solid fa-plus"></i>
                {{ $LANG.Get('buttons.add') }}
            </NevsButton>
            <NevsButton class="secondary" @click="setFilter('everyone')">
                <i class="fa-solid fa-filter"></i>
                {{ $LANG.Get('buttons.everyone') }}
            </NevsButton>
        </div>
        <NevsCard style="clear: both; margin-bottom: 10px;">
            <NevsTextField style="width: 300px; float: left;" v-model="tableData.filters.id" :label="$LANG.Get('fields.id')"></NevsTextField>
            <NevsTextField style="width: 300px; float: left;" v-model="tableData.filters.name" :label="$LANG.Get('fields.name')"></NevsTextField>
            <NevsTextField style="width: 300px; float: left;" v-model="tableData.filters.email" :label="$LANG.Get('fields.officialEmail')"></NevsTextField>
            <NevsTextField style="width: 300px; float: left;" v-model="tableData.filters.oib" :label="$LANG.Get('fields.oib')"></NevsTextField>
            <NevsSelect style="width: 300px; float: left;" :nullable="true" v-model="tableData.filters.financial_status_id" :ajax="'select/financial-statuses'"
                        :label="$LANG.Get('fields.financialStatus')"></NevsSelect>
            <NevsNumberField style="width: 300px; float: left;" v-model="tableData.filters.debt_from"
                             :label="$LANG.Get('fields.debtFrom')"></NevsNumberField>
            <NevsNumberField style="width: 300px; float: left;" v-model="tableData.filters.debt_to"
                             :label="$LANG.Get('fields.debtTo')"></NevsNumberField>
            <NevsDateField style="width: 300px; float: left;" v-model="tableData.filters.valid_until_from"
                           :label="$LANG.Get('fields.validUntilFrom')"></NevsDateField>
            <NevsDateField style="width: 300px; float: left;" v-model="tableData.filters.valid_until_to"
                           :label="$LANG.Get('fields.validUntilTo')"></NevsDateField>
            <NevsDateField style="width: 300px; float: left;" v-model="tableData.filters.warning_date_from"
                           :label="$LANG.Get('fields.warningDateFrom')"></NevsDateField>
            <NevsDateField style="width: 300px; float: left;" v-model="tableData.filters.warning_date_to"
                           :label="$LANG.Get('fields.warningDateTo')"></NevsDateField>
            <NevsDateField style="width: 300px; float: left;" v-model="tableData.filters.block_date_from"
                           :label="$LANG.Get('fields.blockDateFrom')"></NevsDateField>
            <NevsDateField style="width: 300px; float: left;" v-model="tableData.filters.block_date_to"
                           :label="$LANG.Get('fields.blockDateTo')"></NevsDateField>
            <div style="clear: both;"></div>
            <NevsButton class="secondary" @click="filter()">
                <i class="fa-solid fa-filter"></i>
                {{ $LANG.Get('buttons.filter') }}
            </NevsButton>
        </NevsCard>
        <NevsCard v-if="showTable" style="clear: both;">
            <NevsTable
                :default-sort="tableData.defaultSort"
                :fields="tableData.fields"
                :height="tableData.height"
                :total-records="tableData.totalRecords"
                @reload="reloadTable">
                <tr v-for="(item, key) in tableData.records" :key="key" :style="{ 'color' : item.color }">
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.id }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.name }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.email }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.oib }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{
                            item.financial_status_display
                        }}
                    </td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.debt_display }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.valid_until }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.warning_date }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.block_date }}</td>
                    <td>
                        <span :title="$LANG.Get('tooltips.openInNewWindow')" class="nevs-table-button"
                              @click="openClick(item.id, true)"><i class="fa-solid fa-up-right-from-square"></i></span>
                    </td>
                </tr>
            </NevsTable>
        </NevsCard>
        <div v-if="showCreateForm" class="nevs-popup-container">
            <div class="nevs-popup create-client-popup">
                <div class="nevs-popup-text create-client-form">
                    <h3>{{ $LANG.Get('labels.createClient') }}</h3>
                    <NevsTextField :width="'100%'" :error="createValidation.first_name"
                                   :label="$LANG.Get('fields.firstName') + ':'"
                                   v-model="createForm.first_name"></NevsTextField>
                    <NevsTextField :width="'100%'" :error="createValidation.last_name"
                                   :label="$LANG.Get('fields.lastName') + ':'"
                                   v-model="createForm.last_name"></NevsTextField>
                    <NevsTextField :width="'100%'" :error="createValidation.email"
                                   :label="$LANG.Get('fields.email') + ':'"
                                   v-model="createForm.email"></NevsTextField>
                    <NevsTextField :width="'100%'" :error="createValidation.password"
                                   :label="$LANG.Get('fields.password') + ':'"
                                   v-model="createForm.password"></NevsTextField>
                    <NevsTextField :width="'100%'" :error="createValidation.name"
                                   :label="$LANG.Get('fields.name') + ':'"
                                   v-model="createForm.name"></NevsTextField>
                    <NevsTextField :width="'100%'" :error="createValidation.oib"
                                   :label="$LANG.Get('fields.oib') + ':'"
                                   v-model="createForm.oib"></NevsTextField>
                    <NevsTextField :width="'100%'" :error="createValidation.address"
                                   :label="$LANG.Get('fields.address') + ':'"
                                   v-model="createForm.address"></NevsTextField>
                    <NevsTextField :width="'100%'" :error="createValidation.postal_code"
                                   :label="$LANG.Get('fields.postalCode') + ':'"
                                   v-model="createForm.postal_code"></NevsTextField>
                    <NevsTextField :width="'100%'" :error="createValidation.city"
                                   :label="$LANG.Get('fields.city') + ':'"
                                   v-model="createForm.city"></NevsTextField>
                    <NevsTextField :width="'100%'" :error="createValidation.country"
                                   :label="$LANG.Get('fields.country') + ':'"
                                   v-model="createForm.country"></NevsTextField>
                    <NevsCheckbox v-model="createForm.tax_system"
                                  :label="$LANG.Get('fields.taxSystem')"></NevsCheckbox>
                </div>
                <div class="nevs-popup-buttons">
                    <NevsButton class="error" @click="cancelCreate">{{ $LANG.Get('buttons.cancel') }}</NevsButton>
                    <NevsButton class="success" @click="createClick">{{ $LANG.Get('buttons.create') }}</NevsButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTable from "@/components/nevs/NevsTable.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsNumberField from "@/components/nevs/NevsNumberField.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";

export default {
    name: "ModuleClients",
    components: {NevsCheckbox, NevsNumberField, NevsDateField, NevsSelect, NevsTextField, NevsTable, NevsButton, NevsCard},
    data() {
        return {
            tableData: {
                fields: [
                    {
                        name: 'id',
                        label: this.$LANG.Get('fields.id')
                    },
                    {
                        name: 'name',
                        label: this.$LANG.Get('fields.name')
                    },
                    {
                        name: 'email',
                        label: this.$LANG.Get('fields.officialEmail')
                    },
                    {
                        name: 'oib',
                        label: this.$LANG.Get('fields.oib')
                    },
                    {
                        name: 'financial_status',
                        label: this.$LANG.Get('fields.financialStatus')
                    },
                    {
                        name: 'debt',
                        label: this.$LANG.Get('fields.debt')
                    },
                    {
                        name: 'valid_until',
                        label: this.$LANG.Get('fields.validUntil')
                    },
                    {
                        name: 'warning_date',
                        label: this.$LANG.Get('fields.warningDate')
                    },
                    {
                        name: 'block_date',
                        label: this.$LANG.Get('fields.blockDate')
                    },
                    {
                        name: 'actions',
                        width: '50px',
                        label: ''
                    }
                ],
                filters: {
                    id: '',
                    name: '',
                    email: '',
                    oib: '',
                    financial_status_id: null,
                    debt_from: 0,
                    debt_to: 0,
                    valid_until_from: null,
                    valid_until_to: null,
                    warning_date_from: null,
                    warning_date_to: null,
                    block_date_from: null,
                    block_date_to: null
                },
                records: [],
                lastRequest: null,
                totalRecords: 0,
                defaultSort: {
                    field: 'id',
                    descending: true
                },
                filterTimer: null,
                height: '0px'
            },
            showTable: false,
            showCreateForm: false,
            createForm: {
                first_name: '',
                last_name: '',
                email: '',
                password: '',
                name: '',
                oib: '',
                address: '',
                postal_code: '',
                city: '',
                country: 'Hrvatska',
                tax_system: false
            },
            createValidation: {
                first_name: '',
                last_name: '',
                email: '',
                password: '',
                name: '',
                oib: '',
                address: '',
                postal_code: '',
                city: '',
                country: ''
            }
        }
    },
    methods: {
        filter() {
            if (!this.showTable) {
                this.showTable = true;
            } else {
                this.reloadTable(this.tableData.lastRequest);
            }
        },
        setFilter(type) {
            if (type == 'everyone') {
                this.tableData.filters = {
                    id: '',
                    name: '',
                    email: '',
                    oib: '',
                    financial_status_id: null,
                    debt_from: 0,
                    debt_to: 0,
                    valid_until_from: null,
                    valid_until_to: null,
                    warning_date_from: null,
                    warning_date_to: null,
                    block_date_from: null,
                    block_date_to: null
                }
            }
        },
        openClick(id, newWindow = false) {
            if (newWindow) {
                let routeData = this.$router.resolve('/clients/' + id);
                window.open(routeData.href);
            } else {
                this.$router.push('/clients/' + id);
            }
        },
        addClick() {
            this.resetCreateForm();
            this.showCreateForm = true;
        },
        resetCreateForm() {
            this.createForm = {
                first_name: '',
                last_name: '',
                email: '',
                password: '',
                name: '',
                oib: '',
                address: '',
                postal_code: '',
                city: '',
                country: 'Hrvatska',
                tax_system: false
            };
            for (const key of Object.keys(this.createValidation)) {
                this.createValidation[key] = '';
            }
        },
        cancelCreate() {
            this.showCreateForm = false;
        },
        createClick() {
            let valid = true;
            const mandatory = ['first_name', 'last_name', 'password', 'name', 'oib', 'address', 'postal_code', 'city', 'country'];
            for (const key of Object.keys(this.createValidation)) {
                this.createValidation[key] = '';
            }
            for (const field of mandatory) {
                if (this.createForm[field] === '') {
                    this.createValidation[field] = this.$LANG.Get('labels.mandatoryField');
                    valid = false;
                }
            }
            if (this.createForm.email === '') {
                this.createValidation.email = this.$LANG.Get('labels.mandatoryField');
                valid = false;
            } else if (!this.$HELPERS.CheckEmail(this.createForm.email)) {
                this.createValidation.email = this.$LANG.Get('labels.invalidEmailAddress');
                valid = false;
            }
            if (!valid) return;

            let vm = this;
            this.$API.APICall('post', 'clients', this.createForm, (data, success) => {
                if (success) {
                    vm.showCreateForm = false;
                    vm.$LOCAL_BUS.TriggerEvent('notification', {text: vm.$LANG.Get('alerts.recordSaved')});
                    if (vm.tableData.lastRequest !== null) {
                        vm.$CROSS_TAB_BUS.TriggerEvent('reload-clients', {});
                    }
                } else if (data !== undefined && data.error === 'oib exists') {
                    vm.createValidation.oib = vm.$LANG.Get('alerts.oibDuplicate');
                } else if (data !== undefined && data.error === 'email exists') {
                    vm.createValidation.email = vm.$LANG.Get('alerts.emailDuplicate');
                } else {
                    vm.$LOCAL_BUS.TriggerEvent('popup', {text: vm.$LANG.Get('alerts.serverError'), type: 'alert'});
                }
            });
        },
        reloadTable(request) {
            let vm = this;
            request.filters = this.tableData.filters;
            this.tableData.lastRequest = JSON.parse(JSON.stringify(request));
            this.$API.APICall('get', 'clients', request, (data, success) => {
                if (success) {
                    vm.tableData.records = data.records;
                    vm.tableData.totalRecords = data.total_records;
                } else {
                    vm.$LOCAL_BUS.TriggerEvent('popup', {text: vm.$LANG.Get('alerts.serverError'), type: 'alert'});
                }
            });
        },
        resolveWindowResize() {
            this.tableData.height = window.innerHeight - 205 + 'px';
        }
    },
    mounted() {
        this.$store.commit('selectMenu', 'clients');
        this.$store.commit('selectSubMenu', null);
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.clients'),
                link: null
            }
        ]);
        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
        let vm = this;
        this.$CROSS_TAB_BUS.ListenToEvent('reload-clients', () => {
            vm.reloadTable(vm.tableData.lastRequest);
        });
    }
}
</script>

<style scoped>
.create-client-popup {
    width: 500px;
    max-width: 90%;
}

.create-client-form {
    max-height: 70vh;
    overflow-y: auto;
}

.create-client-form h3 {
    margin-top: 0;
}
</style>
